export type IdentidadCorporativaId =
  | 'corp-admin-01'
  | 'corp-agente-01'
  | 'corp-jefe-01'
  | 'corp-director-01'
  | 'corp-soporte-01';

export interface IdentidadSinteticaLocal {
  corporateIdentityId: IdentidadCorporativaId;
  label: string;
  perfilEsperado: string;
  mfaVerificado: boolean;
}

export const IDENTIDADES_SINTETICAS: IdentidadSinteticaLocal[] = [
  {
    corporateIdentityId: 'corp-admin-01',
    label: 'Administrador',
    perfilEsperado: 'administrador',
    mfaVerificado: true,
  },
  {
    corporateIdentityId: 'corp-agente-01',
    label: 'Agente de ventas',
    perfilEsperado: 'agente_ventas',
    mfaVerificado: false,
  },
  {
    corporateIdentityId: 'corp-jefe-01',
    label: 'Jefe comercial',
    perfilEsperado: 'jefe_comercial',
    mfaVerificado: false,
  },
  {
    corporateIdentityId: 'corp-director-01',
    label: 'Director',
    perfilEsperado: 'director',
    mfaVerificado: false,
  },
  {
    corporateIdentityId: 'corp-soporte-01',
    label: 'Soporte',
    perfilEsperado: 'soporte',
    mfaVerificado: false,
  },
];

export const IDENTIDAD_STORAGE_KEY = 'catalogos-comerciales.local-identity';
